import {companiesService} from "@/_services";
import router from "@/router";

export default {
  getAll({dispatch, commit}, {page, sort, search}) {
    companiesService.getAll(page, sort, search)
      .then(
        companies => {
          commit("setCompaniesData", companies)
          return Promise.resolve(companies);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  showCompany({dispatch}, {company}) {
    return companiesService.showCompany(company)
      .then(
        companies => {
          return Promise.resolve(companies);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  createCompany({dispatch, commit}, {company, aclChangeRole}) {
    dispatch("alert/clear", {}, {root:true});
    return companiesService.createCompany(company)
      .then(
        () => {
          dispatch("companies/getAll", {page: 0}, {root: true});
          return dispatch("account/me", {aclChangeRole}, {root:true}).then(
            () => {
              dispatch("alert/success", "Se agregó la Carpeta de trabajo con éxito", {root:true});
              return Promise.resolve();
            }
          )
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject(error);
        }
      )
  },
  updateCompany({dispatch, commit}, {company, aclChangeRole}) {
    dispatch("alert/clear", {}, {root:true});
    return companiesService.updateCompany(company)
      .then(
        () => {
          dispatch("companies/getAll", {page: 0}, {root: true});
          dispatch("account/me", {aclChangeRole}, {root:true});
          dispatch("alert/success", "Se actualizó la Carpeta de trabajo con éxito", {root:true});
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject(error);
        }
      )
  },
}
